import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import CarouselLeft from '../../../assets/img/rewamp/icons/carousel-left.svg';
import CarouselRight from '../../../assets/img/rewamp/icons/carousel-right.svg';
import JeffImg from '../../../assets/img/rewamp/agents/jeff.jpg';
import RobImg from '../../../assets/img/rewamp/agents/rob.jpg';
import DanImg from '../../../assets/img/rewamp/agents/dan.jpg';
import KrisImg from '../../../assets/img/rewamp/agents/kris.jpg';
import PaulImg from '../../../assets/img/rewamp/agents/paul.jpg';
// import CrinaImg from '../../../assets/img/rewamp/agents/crina.jpg';
import JebidiahImg from '../../../assets/img/rewamp/agents/jebidiah.jpg';
import VladImg from '../../../assets/img/rewamp/agents/vlad.jpg';
// import DarrylImg from '../../../assets/img/rewamp/agents/darryl.jpg';

const team = [

    // {
    //     "name": "Robert Watson",
    //     "desc": "A tried-and-tested domain broker with more than 1,000 successful sales.",
    //     "sales": ["note.com", "yolo.com", "anna.com", "busy.com", "selling.com", "hosting.com"],
    //     "img": RobImg
    // },
    {
        "name": "Kris Hou",
        "desc": "10+ years of domain name sales experience and a deep knowledge of the Asian Markets.",
        "sales": ["cool.com", "perfect.com", "fancy.com", "virtual.com"],
        "img": KrisImg
    },
    {
        "name": "Paul Thomson",
        "desc": "A sales pro since the 80s (sorry Paul!) with extensive branding knowledge.",
        "sales": ["aliens.com", "nonfiction.com", "edstart.com", "legging.com", "plane.com"],
        "img": PaulImg
    },
    //  {
    //     "name": "Darryl Lopes",
    //     "desc": "With over 14 years of industry experience, Darryl has completed countless domain sales totaling tens of millions of dollars and is a published author on domain strategy.",
    //     "sales": ["drink.com", "remote.com", "chime.com", "rapunzel.com", "forexbrokers.com"],
    //     "img": DarrylImg
    // },
    // {
    //     "name": "Crina Vele",
    //     "desc": "With more than nine years of experience in the digital and domain industry, Crina brings deep expertise across domain strategy, acquisitions, recoveries, negotiations, and portfolio management.",
    //     "sales": [],
    //     "img": CrinaImg
    // },
    {
        "name": "Jebidiah Burnett",
        "desc": "14 years of domain sales experience, specializing in gTLDs and ccTLDs.",
        "sales": ["home.loans", "sex.live", "personalinjuryattorney.com", "homes.forsale", "vmc.in"],
        "img": JebidiahImg
    },
    {
        "name": "Daniel Williams",
        "desc": "With over 25 years of experience in sales and account management ready to navigate your negotiations.",
        "sales": ["skinbit.com", "paragonlabs.com", "rgr.org", "arthropoda.org"],
        "img": DanImg
    },
    {
        "name": "Vlad Kaplunov",
        "desc": "A vital part of the Saw.com team, overseeing domain transfers, customer care and operational support.",
        "sales": [],
        "img": VladImg
    },
    {
        "name": "Jeffrey Gabriel",
        "desc": "15+ years of global domain name sales experience with some impressive wins.",
        "sales": ["sex.com", "ai.com", "media.com", "CO2.com", "data.ai"],
        "img": JeffImg
    },
];

export default function TeamCarousel() {
    // Initialize Embla with loop and alignment options
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: 'center',
        skipSnaps: false
    });

    // Callback functions for your custom arrows
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    return (
        <div className="team-carousel-wrapper">
            {/* Custom SVG Arrows positioned absolutely via CSS */}
            <img
                src={CarouselLeft}
                className="arrow-left"
                onClick={scrollPrev}
                alt="Previous"
            />
            <img
                src={CarouselRight}
                className="arrow-right"
                onClick={scrollNext}
                alt="Next"
            />

            {/* Embla Viewport */}
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {team.map((item, i) => (
                        <div key={i} className="embla__slide">
                            <div className="card-wrapper">
                                <div className="card">
                                    <img src={item.img} className="avatar" alt={item.name} />
                                    <h3>{item.name}</h3>
                                    <div className="agent-desc">{item.desc}</div>
                                    {item.sales?.length ? <div className="notable-sales">Notable Sales:</div> : <></>}
                                    <div className="sales">
                                        {item.sales.map((s, idx) => (
                                            <span key={idx}>{s}</span>
                                        ))}
                                    </div>
                                    {<div className="speaks">
                                        Speaks: <span className="brok-lang">{item.name === "Vlad Kaplunov" ? "Russian and English" : "English"}</span>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}